import { useSelector } from 'react-redux';
import State from 'store/State';

export const selectShareUsers = (state: State) => state.app.shareUsers;

export const useSelectShareUsers = () => useSelector(selectShareUsers);
